import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

/**
 * WorkflowDialogShell - full-screen app-bar dialog for add/edit flows.
 *
 * Use this for screen-like workflows so desktop and mobile share the same
 * save/cancel interaction language.
 */
export default function WorkflowDialogShell({
  open,
  onClose,
  onSave,
  title,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
  children,
  saveDisabled = false,
  saveColor = 'inherit',
  transitionComponent,
}) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={transitionComponent}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 0,
          padding: 0,
          margin: 0,
          width: '100%',
          maxWidth: '100%',
          height: '100%',
          maxHeight: '100%',
        },
      }}
    >
      <AppBar
        sx={{
          position: 'relative',
          color: 'common.white',
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 56, sm: 64 },
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
          <Button
            color="inherit"
            onClick={onClose}
            sx={{
              alignSelf: 'center',
              lineHeight: 1.2,
              minWidth: 'auto',
              color: 'common.white',
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            color={saveColor}
            onClick={onSave}
            disabled={saveDisabled}
            sx={{
              alignSelf: 'center',
              lineHeight: 1.2,
              minWidth: 'auto',
              color: saveDisabled ? 'rgba(255,255,255,0.6)' : 'common.white',
            }}
          >
            {saveLabel}
          </Button>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          minHeight: 0,
          overflowY: 'auto',
          p: { xs: 2, sm: 3 },
          bgcolor: 'background.default',
        }}
      >
        {children}
      </Box>
    </Dialog>
  );
}
